import type { ItemCard } from "@ebay/experience-types-ebay";
import type { Locality } from "@ebay/locale-ebay";
import { PAGE_ID } from "../../../utils/tracking";
import { textFromTD } from "../../../utils/text";

const IFH_DSA_REPORT_CONTENT = "IFH_DSA_REPORT_CONTENT";
const CONTENT_TYPE_PRODUCT_OR_LISTING = "PRODUCT_OR_LISTING";

export function loadHelp(card: ItemCard, locality?: Locality) {
  const itemId = card?.listingId ?? "";
  const titleDescription = textFromTD(card?.title) ?? "";
  const imageUrl = card?.image?.URL ?? "";

  if (!itemId || !titleDescription || !imageUrl) {
    console.warn("IFH_DSA_REPORT_CONTENT: Missing required fields", {
      itemId,
      titleDescription,
      imageUrl,
    });
    return;
  }

  const eventData = {
    context: {
      siteId: locality?.siteId ?? 0,
      pageId: Number(PAGE_ID),
      reportingChannel: "WEB",
    },
    data: [
      {
        contentType: CONTENT_TYPE_PRODUCT_OR_LISTING,
        entity: [
          {
            entityId: itemId,
            attributes: {
              text: titleDescription,
              imageURL: imageUrl,
            },
          },
        ],
      },
    ],
  };

  const ifhCustomEvent = new CustomEvent(IFH_DSA_REPORT_CONTENT, {
    detail: eventData,
  });

  document.dispatchEvent(ifhCustomEvent);
}
